import controller from './date-selector.controller'
import template from './date-selector.html'

const DateSelectorComponent = {
	bindings: {
		language: '<',
		onChange: '&'
	},
	controller,
	template,
};

export default DateSelectorComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/date-selector/date-selector.component.js